





















import Vue from "vue";
import axios from "axios";

export default Vue.extend({
  props: {
    initialState: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      active: this.initialState,
      loading: false
    };
  },

  methods: {
    async toggle() {
      if (this.loading) {
        return;
      }

      this.active = !this.active;
      this.loading = true;

      try {
        const {
          data: { data }
        } = await axios.patch("/ajax/account", {
          active: this.active
        });

        this.active = data.active;
      } catch {
        this.active = !this.active;
      } finally {
        this.loading = false;
      }
    }
  }
});
